import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withReuseDefaultRoute } from './withReuseDefaultRoute';
import ChemHeader from '../ChemHeader';
import Restricted from '../Restricted';
import Confirm from '../Confirm';
import TreeMenu from '../TreeMenu';
import Help from './Help';
import Home from './Home';
import Search from './Search';
import Bottles from './Bottles';
import Bottle from './Bottle';
import Chemicals from './Chemicals';
import Chemical from './Chemical';
import Orders from './Orders';
import Order from './Order';
import Safety from './Safety';
import ShoppingCart from './ShoppingCart';
import Usage from './Usage';
import CampusTransfer from './CampusTransfer';
import Inventory from './Inventory';
import CheckedOut from './CheckedOut';
import Donate from './Donate';

class Reuse extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var newTreeMenuItems = this.copyObject(treeMenuItems);
		
		// remove anything not authorized for the general public
		if (props.user.reuse.authLevel < 1) {
			this.removeRoute(newTreeMenuItems, routes.bottles);
			this.removeRoute(newTreeMenuItems, routes.chemicals);
			this.removeRoute(newTreeMenuItems, routes.safety);
			this.removeRoute(newTreeMenuItems, routes.usage);
			this.removeRoute(newTreeMenuItems, routes.transfer);
			this.removeRoute(newTreeMenuItems, routes.inventory);
			this.removeRoute(newTreeMenuItems, routes.checkedout);
			this.removeRouteByLabel(newTreeMenuItems, 'Admin');
		} else {
			// add hidden elements to Admin form
			var adminMenuItem = this.findMenuItemByLabel(newTreeMenuItems, 'Admin');
			if (adminMenuItem !== null) {
				if (this.isDevelopment()) {
					adminMenuItem.action = 'http://localhost:8000' + adminMenuItem.action;
				}
				adminMenuItem.data = {
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					redirect: '/chempy/admin/reuse'
				};
			}
		}
		
		this.state = {
			treeMenuItems: newTreeMenuItems,
			shoppingCart: [],
			bottleEditable: false,
			chemicalEditable: false,
			locationConfirmed: false,
			fullScreen: false,
			menuWidth: 2,
			renderKey: 1,
			confirm: ''
		};
	}
	
	addToCart(item) {
		// find the max existing id
		var i;
		var maxId = -1;
		for (i = 0; i < this.state.shoppingCart.length; i++) {
			if (this.state.shoppingCart[i].id > maxId) maxId = this.state.shoppingCart[i].id;
		}
		
		// create new cart item
		var cartItem = {
			id: maxId + 1,
			ITEM_ID: item.ITEM_ID,
			BOTTLE_ID: item.BOTTLE_ID,
			CAS_NUMBER: item.CAS_NUMBER,
			CHEM_NAME: item.CHEM_NAME,
			QTY: 1,
			STATUS_FLAG: 1,
			ITEM_DESC: item.CHEM_NAME + ' (BottleID: ' + item.BOTTLE_ID + ')'
		};
		
		// copy state and add new cart item
		var newState = this.copyObject(this.state);
		newState.shoppingCart.push(cartItem);
		
		// assign new line numbers
		for (i = 0; i < newState.shoppingCart.length; i++) {
			newState.shoppingCart[i].LINE_ID = i + 1;
		}
		this.setState(newState);
	}
	
	itemInCart(itemId) {
		for (var i = 0; i < this.state.shoppingCart.length; i++) {
			if (this.state.shoppingCart[i].ITEM_ID === itemId) return true;
		}
		return false;
	}
	
	clearNewOrder() {
		var newState = this.copyObject(this.state);
		newState.shoppingCart = [];
		newState.newOrder = null;
		this.setState(newState);
	}
	
	removeFromCart(itemId) {
		var self = this;
		
		if (itemId === undefined) {
			this.showOKCancel('Confirm Clear Cart', 'Remove all items from shopping cart?', (okClicked) => {
				if (okClicked) {
					var newState = self.copyObject(self.state);
					newState.shoppingCart = [];
					self.setState(newState);
				}
			});
		} else {
			var i;

			// copy state and remove shopping cart item
			var newState = this.copyObject(this.state);
			for (i = 0; i < newState.shoppingCart.length; i++) {
				if (newState.shoppingCart[i].ITEM_ID === itemId) {
					newState.shoppingCart.splice(i, 1);
					break;
				}
			}
			
			// assign new line numbers
			for (i = 0; i < newState.shoppingCart.length; i++) {
				newState.shoppingCart[i].LINE_ID = i + 1;
			}
			this.setState(newState);
		}
	}
	
	checkout() {
		var dtNow = new Date().toLocaleString({
			year: '2-digit',
			month: 'numeric',
			day: 'numeric',
		});
		// create a new order from the shopping cart
		var order = {
			shopping_cart: {
				CART_ID: null,
				USER_ID: this.props.user.personID,
				CREATE_DATE: dtNow,
				STATUS_FLAG: 2, // open
				COMMENTS: '',
				MODIF_DATE: dtNow,
				MODIF_BY: this.props.user.name,
				LAST_STATUS_EMAIL: null,
				DELIV_BY: null
			},
			unfilled: this.copyObject(this.state.shoppingCart),
			filled: []
		};
		
		// select ids/line IDs/status for unfilled
		for (var i = 0; i < order.unfilled.length; i++) {
			order.unfilled[i].id = i;
			order.unfilled[i].LINE_ID = i;
			order.unfilled[i].STATUS_FLAG = 1;
			order.unfilled[i].LINE_STATUS = 'Submitted';
		}
		
		// add to state
		this.mergeState({
			newOrder: order
		}, () => {
			this.props.navigate('/Reuse/Orders/new');
		});
	}
	
	setMenuWidth(newWidth) {
		if (newWidth > 12) newWidth = 12;
		else if (newWidth < 1) newWidth = 1;
		
		this.mergeState({
			menuWidth: newWidth,
			renderKey: this.state.renderKey + 1
		});
	}

	removeRoute(menuItems, route) {
		for (var i = 0; i < menuItems.length; i++) {
			if (menuItems[i].nodes) {
				this.removeRoute(menuItems[i].nodes, route);
				if (menuItems[i].nodes.length === 0) {
					menuItems.splice(i--, 1);
				}
			} else {
				if (menuItems[i].route && menuItems[i].route.toUpperCase() === route.toUpperCase()) {
					menuItems.splice(i--, 1);
				}
			}
		}
	}
	
	removeRouteByLabel(menuItems, label) {
		for (var i = 0; i < menuItems.length; i++) {
			if (menuItems[i].nodes) {
				this.removeRouteByLabel(menuItems[i].nodes, label);
				if (menuItems[i].nodes.length === 0) {
					menuItems.splice(i--, 1);
				}
			} else {
				if (menuItems[i].label && menuItems[i].label.toUpperCase() === label.toUpperCase()) {
					menuItems.splice(i--, 1);
				}
			}
		}
	}

	findMenuItemByLabel(menuItems, label) {
		for (var i = 0; i < menuItems.length; i++) {
			if (menuItems[i].nodes) {
				var subItem = this.findMenuItemByLabel(menuItems[i].nodes, label);
				if (subItem !== null) return subItem;
			} else {
				if (menuItems[i].label && menuItems[i].label.toUpperCase() === label.toUpperCase()) {
					return menuItems[i];
				}
			}
		}
		
		return null;
	}

	showConfirmation(message) {
		var self = this;
		this.mergeState({
			confirm: message
		}, () => self.props.navigate('/Reuse/Confirm'));
	}
	
	newOrderBelongsToCurrentUser() {
		// if there is a logged in user and a new order
		if (this.props.user && this.state.newOrder && this.state.newOrder.shopping_cart) {
			// make sure logged in user matches shopping cart user
			return this.props.user.personID === this.state.newOrder.shopping_cart.USER_ID;
		}
		
		return false;
	}

	render() {
		return (<>
			<ChemHeader parent={this} user={this.props.user} title='Reuse Facility' fullScreen={this.state.fullScreen} 
				toggleFullScreen={(fullScreen) => this.mergeState({ fullScreen: fullScreen, renderKey: this.state.renderKey + 1 })}
				showHelp={() => this.props.navigate('/Reuse/Help', { helpPath: this.props.location.pathname })} />
			<Container fluid style={{ paddingTop: 20, paddingBottom: 20, backgroundColor: '#e6e6e4', height: 'calc(100vh - 64px)', overflow: 'auto' }}>
				<Row>
					{!this.state.fullScreen && <Col xs={this.state.menuWidth}>
						<TreeMenu parent={this} menuItems={this.state.treeMenuItems} selectedRoute={this.props.location.pathname} />
						{this.state.locationConfirmed && <ShoppingCart parent={this} user={this.props.user} 
							shoppingCart={this.state.shoppingCart} menuWidth={this.state.menuWidth}
							setMenuWidth={(newWidth) => this.setMenuWidth(newWidth)}
							removeFromCart={(itemId) => this.removeFromCart(itemId)}
							checkout={() => this.checkout()} />}
					</Col>}
					<Col xs={this.state.fullScreen ? 12 : (12 - this.state.menuWidth)}>
					  <main id='main'>
						<Routes>
							<Route path={'/home'} element={
								<Home parent={this} user={this.props.user} confirmLocation={(locationConfirmed) => this.mergeState({ locationConfirmed: locationConfirmed })} />
							} />
							<Route path={'/search'} element={
								<Restricted authorized={this.state.locationConfirmed}
									message={<>Please confirm your delivery location on the <a href='/Reuse/Home'>Home page</a> before proceeding.</>}>
									<Search parent={this} user={this.props.user} 
										setBottleEditable={(bottleEditable) => this.mergeState({ bottleEditable: bottleEditable })}
										locationConfirmed={this.state.locationConfirmed}
										addToCart={(item) => this.addToCart(item)}
										itemInCart={(itemId) => this.itemInCart(itemId)}
										removeFromCart={(itemId) => this.removeFromCart(itemId)} />
								</Restricted>
							} />
							<Route path={'/bottles'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Bottles parent={this} user={this.props.user} 
										setBottleEditable={(bottleEditable) => this.mergeState({ bottleEditable: bottleEditable })} />
								</Restricted>
							} />
							<Route path={'/bottles/new'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Bottle parent={this} user={this.props.user} editable={true} />
								</Restricted>
							} />
							<Route path={'/bottles/new/:activeTab'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Bottle parent={this} user={this.props.user} editable={true} />
								</Restricted>
							} />
							<Route path={'/bottles/:itemId'} element={
									<Bottle parent={this} user={this.props.user} editable={this.props.user.reuse && this.props.user.reuse.authLevel > 0 && this.state.bottleEditable}
										addToCart={(item) => this.addToCart(item)} 
										itemInCart={(itemId) => this.itemInCart(itemId)}
										removeFromCart={(itemId) => this.removeFromCart(itemId)} />
							} />
							<Route path={'/bottles/:itemId/:activeTab'} element={
									<Bottle parent={this} user={this.props.user} editable={this.props.user.reuse && this.props.user.reuse.authLevel > 0 && this.state.bottleEditable}
										addToCart={(item) => this.addToCart(item)}
										itemInCart={(itemId) => this.itemInCart(itemId)}
										removeFromCart={(itemId) => this.removeFromCart(itemId)} />
							} />
							<Route path={'/chemicals'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Chemicals parent={this} user={this.props.user} 
										setChemicalEditable={(chemicalEditable) => this.mergeState({ chemicalEditable: chemicalEditable })} />
								</Restricted>
							} />
							<Route path={'/chemicals/new'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Chemical parent={this} user={this.props.user} editable={true} />
								</Restricted>
							} />
							<Route path={'/chemicals/new/:activeTab'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Chemical parent={this} user={this.props.user} editable={true} />
								</Restricted>
							} />
							<Route path={'/chemicals/:chemId'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Chemical parent={this} user={this.props.user} editable={this.state.chemicalEditable} />
								</Restricted>
							} />
							<Route path={'/chemicals/:chemId/:activeTab'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Chemical parent={this} user={this.props.user} editable={this.state.chemicalEditable} />
								</Restricted>
							} />
							<Route path={'/orders'} element={
								<Orders parent={this} user={this.props.user} />
							} />
							<Route path={'/orders/new'} element={
								<Order parent={this} user={this.props.user} order={this.state.newOrder} clearNewOrder={() => this.clearNewOrder()} />
							} />
							<Route path={'/orders/:cartId'} element={
								<Order parent={this} user={this.props.user} />
							} />
							<Route path={'/safety'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Safety parent={this} user={this.props.user} 
										setChemicalEditable={(chemicalEditable) => this.mergeState({ chemicalEditable: chemicalEditable })} />
								</Restricted>
							} />
							<Route path={'/safety/:activeTab'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Safety parent={this} user={this.props.user} 
										setChemicalEditable={(chemicalEditable) => this.mergeState({ chemicalEditable: chemicalEditable })} />
								</Restricted>
							} />
							<Route path={'/donate'} element={
								<Donate parent={this} user={this.props.user} />
							} />
							<Route path={'/usage'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Usage parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/campustransfer'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<CampusTransfer parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/inventory'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<Inventory parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/checkedout'} element={
								<Restricted authorized={this.props.user.reuse && this.props.user.reuse.authLevel > 0}>
									<CheckedOut parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/confirm'} element={
								<Confirm parent={this} user={this.props.user} message={this.state.confirm} />
							} />
							<Route path={'/help'} element={
								<Help parent={this} user={this.props.user} />
							} />
						</Routes>
					  </main>
					</Col>
				</Row>
			</Container>
		</>);
	}
}

// routes defined here so there are no accidents when removing them!
const routes = {
	bottles: '/Reuse/Bottles',
	checkedout: '/Reuse/CheckedOut',
	chemicals: '/Reuse/Chemicals',
	donate: '/Reuse/Donate',
	home: '/Reuse/Home',
	inventory: '/Reuse/Inventory',
	orders: '/Reuse/Orders',
	safety: '/Reuse/Safety',
	search: '/Reuse/Search',
	transfer: '/Reuse/CampusTransfer',
	usage: '/Reuse/Usage'
};

const treeMenuItems = [
	{
		label: 'Home',
		route: routes.home
	},
	{
		label: 'Search',
		route: routes.search
	},
	{
		label: 'Bottles',
		route: routes.bottles
	},
	{
		label: 'Chemicals',
		route: routes.chemicals
	},
	{
		label: 'Safety Search',
		route: routes.safety
	},
	{
		label: 'Orders',
		route: routes.orders
	},
	{
		label: 'Donate',
		route: routes.donate
	},
	{
		label: 'Reports',
		nodes: [
			{
				label: 'Usage',
				route: routes.usage
			},
			{
				label: 'Campus Transfer',
				route: routes.transfer
			},
			{
				label: 'Inventory',
				route: routes.inventory
			},
			{
				label: 'Checked Out',
				route: routes.checkedout
			}
		]
	},
	{
		label: 'Admin',
		action: '/chempy/login'
	}
];

export default withReuseDefaultRoute(Reuse);